import { Component, OnInit } from '@angular/core';
import { combineLatest, distinctUntilChanged, filter } from 'rxjs';
import { UserService } from 'src/app/common/services/user/user.service';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { ExternalSettings } from '../../services/external-settings/external-settings.interface';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';
import { NavigationEnd, Router } from '@angular/router';
import { HelpDeskService } from 'src/app/business/help-desk/help-desk.service';
import { hasOnePermission, InternalSettingsService } from '../../services/internal-settings/internal-settings.service';
import { PermissionList } from '../../services/internal-settings/internal-settings.interface';
import { SupportCenterService } from 'src/app/business/support-center/support-center.service';


@Component({
    selector: 'app-login-control',
    templateUrl: './login-control.component.html',
    styleUrls: ['./login-control.component.less'],
    standalone: false
})
export class LoginControlComponent implements OnInit {
  externalSettings!: ExternalSettings;
  UIUtilityService: any = UIUtilityService;
  public isParitalLogin: boolean = false;
  public isFullLogin: boolean = false;
  public showQr: boolean = false;
  public hasHelpDesk: boolean = false;
  private readonly qrPermissions : number[] = [PermissionList.SCAN_MERCHANT_QR_CODE, 
                                                PermissionList.SCAN_PEER_QR_CODE,
                                                PermissionList.CREATE_PEER_QR_CODE,
                                                PermissionList.SCAN_ORDER_QR_CODE,
                                                PermissionList.CREATE_ORDER_QR_CODE,
                                                PermissionList.SCAN_EXTERNAL_EFT_QR_CODE,
                                                PermissionList.CREATE_EXTERNAL_EFT_QR_CODE];

  constructor(
    private srvES: ExternalSettingsService,
    private srvIS: InternalSettingsService,
    private srvUser: UserService,
    private router: Router,
    private srvHelpDesk: HelpDeskService,
    private srvSupport: SupportCenterService,
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.srvES.externalSettings$,
    ]).subscribe(([externalSettings]) => {
      this.externalSettings = externalSettings;
      this.isParitalLogin = UserService.isPartialLogon(this.router.url);
    });

    this.srvIS.internalSettings$.subscribe((is) => {
      if (is) {
        let module = this.externalSettings.globalVariables.isModuleEnabledQRCode;
        let permission = hasOnePermission(this.qrPermissions, is.permissions);
        this.showQr = module && permission;
      }
    })

    this.srvSupport.showHelpDesk$.subscribe((show: boolean)=>{
      this.hasHelpDesk = show;
    })

    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      distinctUntilChanged(),
    ).subscribe((nav: NavigationEnd) => {      
      this.isParitalLogin = UserService.isPartialLogon(nav.url);
    });


    this.srvUser.isLoggedIn$.subscribe((isLoggedIn) => {
        this.isFullLogin = isLoggedIn;
    });

  }

  logoff() {
    if (this.hasHelpDesk) {
      this.srvHelpDesk.closeTicket(true).subscribe(()=>{
        this.srvUser.logoff();
      });
    } else {
      this.srvUser.logoff();
    }
  }
}
